export enum UserType {
  FirstParty="first-party",
  ThirdParty="third-party",
}
